/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom"
import Breadcrumb from "./Breadcrumb";
import Card from "./Card";
import FormInput from "./FormInput";
import LoadingAlert from "./LoadingAlert";
import withParams from "./WithParams";
import { qreq } from "../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { SidebarGlobal } from "./_SidebarGlobal";
import Icon from "./Icon";
import AppActions from "./AppActions";
import L from "./Lang";
import HTMLEditor from './HTMLEditor';
import React from 'react';

class QuoteView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            item: {
                quoteDate: new Date(),
                estimatedDueDate: new Date(),
                shippingTotal: 0
            },
            saving: false,
            organizations: [],
            accounts: []
        };
        if (this.props.params.id) {
            this.id = this.props.params.id;
            this.state.loading = true;
        }

        this.submitRef = React.createRef();
    }

    async componentDidMount() {

        qreq.post('/api/organization/list', {}, j => {
            if (j.list)
                this.setState({ organizations: j.list });
        });

        qreq.get('/api/account/list', j => {
            if (j.list)
                this.setState({ accounts: j.list });
        });


        await this.getSettings();

        this.load();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = () => {
        if (this.props.params.id) {
            qreq.get('/api/quote/get/' + this.props.params.id, j => {
                if (j.errorCode)
                    alert(j.errorMessage);
                else {
                    this.setState({ item: j.item });
                }
                this.setState({ loading: false });
            }, e => {
                this.goBack();
            });
        }
    }


    submit = (e) => {
        if (e)
            e.preventDefault();

        var item = { ...this.state.item };


        this.setState({ saving: true });

        qreq.post('/api/quote/save', item, (j) => {
            if (j.errorCode !== 0)
                alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        });
    }


    itemTypeChanged = (v) => {
        //? just in case
    }

    accountSelected = (v) => {
        qreq.get('/api/account/get/' + v, j => {
            this.setState({ account: j.item });
        });
    }

    changeInfo = (a, b) => {
        let item = { ...this.state.item };
        item[a] = b;
        this.setState({ item });
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Quote</L></h1><LoadingAlert /></div>);


        SidebarGlobal.setSubNav(<><div>
            <button type="button" className="btn btn-primary" onClick={() => this.submitRef.current.click()}> <FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button>
        </div></>);

        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1>Quote #{this.state.item.iid}</h1>
                <Breadcrumb path={[['Quotes', '/quote/list'], [this.id ? 'Edit' : 'New']]} />
                <Card title="Billing Organization">
                    <FormInput model={this.state.item} name="organizationID" label="Organization" type="select" options={this.state.organizations} required />
                </Card>
                <Card title="Quote Info">
                    <FormInput model={this.state.item} name="name" label="Title" type="text" required />

                    <FormInput model={this.state.item} name="accountID" label="Account" type="select"
                        options={this.state.accounts} required onChange={this.accountSelected} />

                    {this.state.account && this.state.account.address ? <div className="bg-light rounded mb-3 p-3"><strong>Address:</strong><br />{this.state.account.address.line1} {this.state.account.address.line2}<br />
                        {this.state.account.address.city} {this.state.account.address.state} {this.state.account.address.country} {this.state.account.address.postalCode}</div> : ''}

                    <div className="row">
                        <div className="col-md-6">
                            <FormInput model={this.state.item} name="quoteDate" label="Quote Date" type="date" required />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="estimatedHours" label="Estimated Hours" type="number" step="1" required />
                        </div>
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="hourRate" label="Hour Rate" type="number" step="0.01" required />
                        </div>
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="weeks" label="Weeks to Deliver" type="number" step="1" required />
                        </div>
                    </div>

                    <FormInput model={this.state.item} name="contactName" label="Contact and Signee Name" type="text" required />

                    <div className="form-group">
                        <label className="form-label"><L>Description</L></label>
                        <HTMLEditor linkValue value={this.state.item.description} className="form-control"
                            onChange={(v) => this.changeInfo('description', v)} />
                    </div>

                    <div className="form-group">
                        <label className="form-label"><L>Terms</L></label>
                        <HTMLEditor linkValue value={this.state.item.terms} className="form-control"
                            onChange={(v) => this.changeInfo('terms', v)} />
                    </div>


                </Card>
                <AppActions>
                    <button type="submit" className="btn btn-success btn-lg" ref={this.submitRef}>
                        <Icon icon="faSave" /> <L>Save</L>
                    </button>
                </AppActions>
            </form>
        </div>;
    }
}

export default withParams(QuoteView);